import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { SideMenu } from '../types';
import { SubMenuList } from './SubMenuList';
import styles from './styles.module.scss';

type Props = SideMenu;

/**
 * メニュー項目コンポーネント
 *
 * @param param0 メニュー項目の型
 * @returns メニュー項目コンポーネント
 */
export const MenuItem: React.FC<Props> = ({ icon, content, link, subMenus, isExternal }) =>
  subMenus ? (
    <div
      className={clsx(styles.MenuItem, {
        [styles.active]: subMenus.some(menu => location.pathname === menu.link),
      })}
    >
      {icon}
      <span>{content}</span>
      <SubMenuList subMenus={subMenus} />
    </div>
  ) : (
    <Link
      className={clsx(styles.MenuItem, {
        [styles.active]: location.pathname === link,
      })}
      to={link}
      target={isExternal ? '_blank' : undefined}
    >
      {icon}
      <span>{content}</span>
    </Link>
  );
